import { useEffect, useState } from "react";
import type { ShiftFormLineUnits } from "../../../shared/shift-production-form/contracts";
import { getShiftFormLineUnits } from "./shift-production-form-gateway";

export function useLineMeasurementUnits() {
  const [items, setItems] = useState<ShiftFormLineUnits>([]);
  const [error, setError] = useState<string | null>(null);
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let active = true;
    setError(null);
    void getShiftFormLineUnits()
      .then((response) => {
        if (active) setItems(response.items);
      })
      .catch(() => {
        if (active) setError("Hattın ölçüm birimi yüklenemedi.");
      });
    return () => {
      active = false;
    };
  }, [version]);
  return { items, error, retry: () => setVersion((current) => current + 1) };
}
